import React from 'react';

interface DragPlaceholderProps {
  height?: string;
  dropZoneProps?: {
    onDragEnter: (e: React.DragEvent) => void;
    onDragOver: (e: React.DragEvent) => void;
    onDragLeave: (e: React.DragEvent) => void;
    onDrop: (e: React.DragEvent) => void;
  };
}

export const DragPlaceholder: React.FC<DragPlaceholderProps> = ({ height = '140px', dropZoneProps }) => {
  return (
    <div
      className="bg-[#E5F8F8] border-dashed border-[#0DB5B5] rounded-md mb-2 flex items-center justify-center transition-all duration-200"
      style={{ height, minHeight: '100px', borderWidth: '0.5px' }}
      onDragEnter={(e) => {
        e.preventDefault();
        e.stopPropagation();
        if (dropZoneProps?.onDragEnter) {
          dropZoneProps.onDragEnter(e);
        }
      }}
      onDragOver={(e) => {
        e.preventDefault();
        e.stopPropagation();
        e.dataTransfer.dropEffect = 'move';
        if (dropZoneProps?.onDragOver) {
          dropZoneProps.onDragOver(e);
        }
      }}
      onDragLeave={(e) => {
        e.stopPropagation();
        if (dropZoneProps?.onDragLeave) {
          dropZoneProps.onDragLeave(e);
        }
      }}
      onDrop={(e) => {
        e.preventDefault();
        e.stopPropagation();
        if (dropZoneProps?.onDrop) {
          dropZoneProps.onDrop(e);
        }
      }}
    >
      <div className="text-center px-4 pointer-events-none">
        <div className="w-8 h-8 mx-auto mb-2">
          <svg viewBox="0 0 24 24" fill="none">
            <path
              d="M12 5V19M5 12H19"
              stroke="#0DB5B5"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <p className="text-xs text-[#0DB5B5] font-medium">Drop here</p>
      </div>
    </div>
  );
};
